'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validateUrlUnicodeSubDomainSegment = require('./validateUrlUnicodeSubDomainSegment');

var _validateUrlUnicodeSubDomainSegment2 = _interopRequireDefault(_validateUrlUnicodeSubDomainSegment);

var _validateUrlUnicodeDomainSegment = require('./validateUrlUnicodeDomainSegment');

var _validateUrlUnicodeDomainSegment2 = _interopRequireDefault(_validateUrlUnicodeDomainSegment);

var _validateUrlUnicodeDomainTld = require('./validateUrlUnicodeDomainTld');

var _validateUrlUnicodeDomainTld2 = _interopRequireDefault(_validateUrlUnicodeDomainTld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Unencoded internationalized domains - this doesn't check for invalid UTF-8 sequences
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlUnicodeDomain = (0, _regexSupplant2.default)(/(?:(?:#{validateUrlUnicodeSubDomainSegment}\.)*(?:#{validateUrlUnicodeDomainSegment}\.)#{validateUrlUnicodeDomainTld})/i, {
  validateUrlUnicodeSubDomainSegment: _validateUrlUnicodeSubDomainSegment2.default,
  validateUrlUnicodeDomainSegment: _validateUrlUnicodeDomainSegment2.default,
  validateUrlUnicodeDomainTld: _validateUrlUnicodeDomainTld2.default
});

exports.default = validateUrlUnicodeDomain;
module.exports = exports['default'];